module.exports = __webpack_public_path__ + "static/images/city-1.f66a21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/city-1.png
// module id = GGaW
// module chunks = 8